import { Model } from "vuex-fetch-factory";
import { AddressRaw, AddressModel } from "./address";

export interface PrivatePersonRaw {
  id: number;
  first_name: string;
  last_name: string;
  gender: string;
  email_address: string;
  phone_number: string;
  mobile_phone_number: string;
  relation_admin: string;
  addresses: AddressRaw[];
}

export class PrivatePersonModel
  implements Model<PrivatePersonModel, PrivatePersonRaw>
{
  public id = 0;
  public first_name = "";
  public last_name = "";
  public gender = "";
  public email_address = "";
  public phone_number = "";
  public mobile_phone_number = "";
  public relation_admin = "";
  public addresses: AddressModel[] = [];

  public getNew(): PrivatePersonModel {
    return new PrivatePersonModel();
  }

  public fillModel(raw: PrivatePersonRaw): this {
    this.id = raw.id;
    this.first_name = raw.first_name;
    this.last_name = raw.last_name;
    this.gender = raw.gender;
    this.email_address = raw.email_address;
    this.phone_number = raw.phone_number;
    this.mobile_phone_number = raw.mobile_phone_number;
    this.relation_admin = raw.relation_admin;

    raw.addresses.forEach((c): void => {
      const model = new AddressModel();
      model.fillModel(c);
      this.addresses.push(model);
    });
    return this;
  }

  public getRaw(): PrivatePersonRaw {
    return {
      id: this.id,
      first_name: this.first_name,
      last_name: this.last_name,
      gender: this.gender,
      email_address: this.email_address,
      phone_number: this.phone_number,
      mobile_phone_number: this.mobile_phone_number,
      relation_admin: this.relation_admin,
      addresses: this.addresses.map((cm): AddressRaw => cm.getRaw()),
    };
  }
}
